import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
    EmpInfo,
    DestroyEmp,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getVthQuarter,
    getVIthQuarter,
    getSchoolYear,
    UpdateEmployeeStatus,
    getAssessmentRegime
} from '../../Api'

import {
    Container,
    ContainerDivs,
    Emp,
    EmployeeInfo,
    Pro,
    ProfilePhoto,
    ProfileInfo,
    EmpName,
    RoleRow,
    RolePill,
    StatusPill,
    DetailGrid,
    DetailItem,
    DivButtomEdit,
    Btt02,
    SectionLabel,
    DivInfo,
    TitleInfo,
    Span,
    Matter,
    EmptyHint,
    Input,
    Label,
    Select,
    ErrorMessage,
    ActionButtons,
    Button,
    ButtonRemove,
    AddMatterSection,
    WarningBox,
    SkeletonHero,
    SkeletonCard,
    SkeletonLine,
    Backdrop,
    Modal,
    ClassList,
    ClassItem,
} from './style';

/* iniciais para o avatar */
const initials = (name = '') =>
    name.trim().split(/\s+/).slice(0, 2).map(n => n[0] || '').join('') || '?';

/* data de nascimento segura (evita "Invalid Date") */
const fmtBirth = (d) => {
    if (!d) return '—';
    const parsed = new Date(d + "T00:00:00");
    return isNaN(parsed) ? '—' : parsed.toLocaleDateString('pt-BR');
};

const EmployeeInformation = () => {

    const navigate = useNavigate()
    const [Clss, setClss] = useState([])
    const [employee, setEmployee] = useState([])
    const [position_at_school, setPosition_at_school] = useState([]);
    const [posi, setPosi] = useState();
    const [loading, setLoading] = useState(false);
    const [Selectbimonthly, setSelectbimonthly] = useState([])
    const [Selectclass, setSelectclass] = useState('')
    const [bimonthly, setbimonthly] = useState([])
    const [school, setSchool] = useState(null);
    const [removeEmp, setRemoveEmp] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [assessmentRegime, setAssessmentRegime] = useState('');
    const { id_employee } = useParams()

    useEffect(() => {
        let cancelled = false;

        (async () => {
            setLoading(true);
            const School = sessionStorage.getItem('School');
            const posi = localStorage.getItem("positionAtEducationDepartment");
            setPosi(posi)
            const idSchool = sessionStorage.getItem("id-school");
            const parsedId = JSON.parse(idSchool);

            sessionStorage.setItem("EmployeeInformation", id_employee)

            // ── FASE 1 (crítico) — regime, ano e dados do funcionário em paralelo ──
            const [response, schoolYear, res] = await Promise.all([
                getAssessmentRegime(parsedId),
                getSchoolYear(parsedId),
                EmpInfo(id_employee),
            ]);

            if (cancelled) return;

            if (response?.data?.data) {
                setAssessmentRegime(response.data.data)
                sessionStorage.setItem('assessmentRegime', response.data.data);
            }

            const position_at_school = res.data.data.map(res => {
                if (res.position_at_school === "SECRETARIO" || res.position_at_school === "DIRETOR/SUPERVISOR") {
                    return res.position_at_school
                } else {
                    return null
                }
            }).filter(res => {
                if (!undefined) {
                    return (res)
                } else {
                    return undefined
                }
            })
            if (position_at_school) {
                setPosition_at_school(position_at_school)
            }
            setEmployee(res.data.data)

            const clss = res.data.data.find(res => {
                return res
            }).id_class.map(res => {
                if (res.year === JSON.stringify(schoolYear.data.data)) {
                    return (res)
                } else {
                    return null
                }
            }).filter(res => {
                if (!null) {
                    return (res)
                } else {
                    return null
                }
            })
            setClss(clss)
            setLoading(false);
            setSchool(School);

            // ── FASE 2 (adiado) — os 6 períodos TODOS EM PARALELO ──
            // (antes eram 6 awaits em série → ~6x mais lento)
            const [
                IstQuarter,
                IIndQuarter,
                IIIrdQuarter,
                IVthQuarter,
                VthQuarter,
                VIthQuarter
            ] = await Promise.all([
                getIstQuarter(schoolYear.data.data, parsedId),
                getIIndQuarter(schoolYear.data.data, parsedId),
                getIIIrdQuarter(schoolYear.data.data, parsedId),
                getIVthQuarter(schoolYear.data.data, parsedId),
                getVthQuarter(schoolYear.data.data, parsedId),
                getVIthQuarter(schoolYear.data.data, parsedId),
            ]);

            if (cancelled) return;

            const i = IstQuarter.data.data.find(res => res) || null;
            const ii = IIndQuarter.data.data.find(res => res) || null;
            const iii = IIIrdQuarter.data.data.find(res => res) || null;
            const iv = IVthQuarter.data.data.find(res => res) || null;
            const v = VthQuarter.data.data.find(res => res) || null;
            const vi = VIthQuarter.data.data.find(res => res) || null;

            setbimonthly([i, ii, iii, iv, v, vi].filter(res => res !== null));
        })()

        return () => { cancelled = true; };
    }, [id_employee])

    const handledaily = () => {
        if (Selectbimonthly.length > 0) {
            const id_cla$$ = Clss.map(clss => {
                return clss
            })
            if (id_cla$$) {
                if (id_cla$$.length <= 1) {
                    const res = Clss.map(clss => {
                        sessionStorage.setItem("Nameclass-daily", JSON.stringify(clss));
                        return clss._id
                    })
                    sessionStorage.setItem("Selectclass-daily", res);
                    navigate('/daily')
                } else if (id_cla$$.length >= 2) {
                    setSelectclass(id_cla$$);
                }
            }

            const id_schll = employee.find(emp => {
                return emp
            })

            sessionStorage.setItem("Selectbimonthly-daily", Selectbimonthly);
            sessionStorage.setItem("Selectteacher-daily", JSON.stringify(id_schll));
            setErrorMessage()
        } else {
            setErrorMessage('Erro, Verifique os dados e tente novamente.');
        }
    };

    const handleSelectClas = (clss) => {
        sessionStorage.setItem("Nameclass-daily", JSON.stringify(clss));
        sessionStorage.setItem("Selectclass-daily", clss._id);
        navigate('/daily')
    }

    const Edit = async () => {
        navigate('/edit-profile')
    }

    // clicar na turma abre a página (perfil) da turma
    const abrirTurma = (clss) => {
        if (!clss?._id) return
        sessionStorage.setItem("ClassInformation", clss._id)
        if (clss.serie) sessionStorage.setItem("serieClass", clss.serie)
        navigate(`/class/info/${clss._id}`)
    }

    const destroyEmp = async () => {
        const idEmployee = sessionStorage.getItem("EmployeeInformation")
        const res = await DestroyEmp(idEmployee)
        if (res) {
            alert('Funcionario removido com sucesso!')
            navigate(-1);
        }
    }

    const handleToggleStatus = async () => {

        const currentEmployee = employee.find(emp => emp)

        if (!currentEmployee) return;

        const isInactive = currentEmployee.status === "inactive";

        // 🔴 REGRA: professor com turma não pode ser inativado
        if (
            currentEmployee.position_at_school === "PROFESSOR" &&
            Clss.length > 0 &&
            !isInactive
        ) {
            alert("Este professor está vinculado a uma turma e não pode ser inativado.");
            return;
        }

        const newStatus = isInactive ? "active" : "inactive";

        const confirmAction = window.confirm(
            `Deseja realmente ${isInactive ? "REATIVAR" : "INATIVAR"} este funcionário?`
        );

        if (!confirmAction) return;

        const res = await UpdateEmployeeStatus(id_employee, newStatus);

        if (res) {
            setEmployee(prev =>
                prev.map(emp =>
                    emp._id === id_employee
                        ? { ...emp, status: newStatus }
                        : emp
                )
            );
            alert(`Funcionário ${isInactive ? "ativado" : "inativado"} com sucesso!`);
        }
    };

    // ── SKELETON ──
    if (loading) {
        return (
            <Container>
                <ContainerDivs>
                    <SkeletonHero />
                    {[1, 2].map((i) => (
                        <SkeletonCard key={i}>
                            <SkeletonLine $w="30%" $h="16px" />
                            <SkeletonLine $w="75%" />
                            <SkeletonLine $w="55%" />
                        </SkeletonCard>
                    ))}
                </ContainerDivs>
            </Container>
        );
    }

    return (
        <Container>
            <ContainerDivs>
                {/* ── HERO: perfil do funcionário ── */}
                {employee.map(emp => {
                    const active = emp.status !== "inactive";
                    return (
                        <Emp key={emp._id}>
                            <EmployeeInfo>
                                <Pro>
                                    <ProfilePhoto>{initials(emp.name)}</ProfilePhoto>
                                    <ProfileInfo>
                                        <EmpName>{emp.name}</EmpName>
                                        <RoleRow>
                                            <RolePill>💼 {emp.position_at_school}</RolePill>
                                            <StatusPill $active={active}>
                                                {active ? 'Ativo' : 'Inativo'}
                                            </StatusPill>
                                        </RoleRow>
                                        {emp.position_at_school_secondary && (
                                            <RoleRow>
                                                <RolePill>➕ {emp.position_at_school_secondary}</RolePill>
                                            </RoleRow>
                                        )}
                                    </ProfileInfo>
                                </Pro>

                                <DetailGrid>
                                    <DetailItem><span className="k">Código</span><span className="v">{emp.EmployeeCode || '—'}</span></DetailItem>
                                    {school && <DetailItem><span className="k">Escola</span><span className="v">{school}</span></DetailItem>}
                                    <DetailItem><span className="k">Celular</span><span className="v">{emp.cellPhone || '—'}</span></DetailItem>
                                    <DetailItem><span className="k">Email</span><span className="v">{emp.email || '—'}</span></DetailItem>
                                    <DetailItem><span className="k">CPF</span><span className="v">{emp.cpf || '—'}</span></DetailItem>
                                    <DetailItem><span className="k">Nascimento</span><span className="v">{fmtBirth(emp.dateOfBirth)}</span></DetailItem>
                                    <DetailItem><span className="k">Endereço</span><span className="v">{emp.address || '—'}</span></DetailItem>
                                </DetailGrid>

                                <DivButtomEdit>
                                    <Btt02 onClick={Edit}>✏️ Editar</Btt02>
                                </DivButtomEdit>
                            </EmployeeInfo>
                        </Emp>
                    );
                })}

                {position_at_school.length === 0 && (
                    <>
                        {/* ── Diário (seletor de bimestre) ── */}
                        {!posi &&
                            <>
                                <SectionLabel>Diário</SectionLabel>
                                <Input>
                                    <h2>Diário do Professor</h2>
                                    <Label>Selecione o bimestre e clique no botão abaixo.</Label>

                                    <Select
                                        id="id-bimonthly"
                                        value={Selectbimonthly}
                                        onChange={(e) => setSelectbimonthly(e.target.value)}
                                    >
                                        <option value="">Selecione</option>

                                        {bimonthly
                                            .filter(res => {
                                                if (assessmentRegime !== 'TRIMESTRAL') return true
                                                return !res.bimonthly.includes('4º')
                                            })
                                            .map(res => (
                                                <option
                                                    key={res._id}
                                                    value={JSON.stringify({
                                                        _id: res._id,
                                                        bimonthly: res.bimonthly
                                                    })}
                                                >
                                                    {assessmentRegime === 'TRIMESTRAL'
                                                        ? res.bimonthly.replace('BIMESTRE', 'TRIMESTRE')
                                                        : res.bimonthly}
                                                </option>
                                            ))
                                        }
                                    </Select>

                                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                    <Button onClick={handledaily}>📔 Ver Diário</Button>
                                </Input>
                            </>
                        }

                        {/* ── Turmas ── */}
                        <SectionLabel>Turmas</SectionLabel>
                        <DivInfo>
                            <TitleInfo><span className="em">🏫</span> Turmas</TitleInfo>
                            {Clss.length > 0 ? (
                                <Matter>
                                    {Clss.map(clss => (
                                        <Span
                                            key={clss._id}
                                            role="button"
                                            tabIndex={0}
                                            title="Abrir a página da turma"
                                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                            onClick={() => abrirTurma(clss)}
                                            onKeyDown={(e) => { if (e.key === 'Enter') abrirTurma(clss) }}
                                        >
                                            {clss.name}
                                        </Span>
                                    ))}
                                </Matter>
                            ) : (
                                <EmptyHint>
                                    <span className="em">🔍</span>
                                    Este professor não está cadastrado em nenhuma turma. Vá até
                                    Turmas, selecione a turma e adicione este professor a uma turma.
                                </EmptyHint>
                            )}
                        </DivInfo>
                    </>
                )}

                {/* ── Aviso de remoção ── */}
                {removeEmp === true && (
                    <AddMatterSection>
                        <WarningBox>
                            {employee.map(emp => (
                                <Span key={emp._id} style={{ color: 'inherit', fontWeight: 600 }}>
                                    Tem certeza que deseja remover o usuário: {emp.name}?
                                </Span>
                            ))}
                        </WarningBox>
                        <ActionButtons>
                            <div>
                                <ButtonRemove onClick={destroyEmp}>🗑️ Remover</ButtonRemove>
                                <Button onClick={() => { setRemoveEmp(false) }}>Cancelar</Button>
                            </div>
                        </ActionButtons>
                    </AddMatterSection>
                )}

                {/* ── Modal: seleção de turma para o diário ── */}
                {Selectclass &&
                    <Backdrop onClick={() => setSelectclass('')}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <h2>Clique em uma turma para ver o diário</h2>
                            <ClassList>
                                {Clss.map(clss => (
                                    <ClassItem
                                        key={clss.id}
                                        onClick={() => { handleSelectClas(clss) }}
                                    >
                                        <span>Série: {clss.serie}</span>
                                        <span>Nome: {clss.name}</span>
                                    </ClassItem>
                                ))}
                            </ClassList>
                            <ActionButtons>
                                <Button
                                    onClick={() => { setSelectclass('') }}
                                    style={{ background: 'var(--surface-2)', color: '#5b6b72' }}
                                >
                                    Cancelar
                                </Button>
                            </ActionButtons>
                        </Modal>
                    </Backdrop>
                }

                {/* ── Ativar / Inativar ── */}
                <ActionButtons style={{ marginTop: 18 }}>
                    {employee.map(emp => {
                        const isInactive = emp.status === "inactive";
                        return (
                            <Button
                                key={emp._id}
                                onClick={handleToggleStatus}
                                style={{
                                    backgroundColor: isInactive ? "#1d8b5a" : "#cf3a3a",
                                    boxShadow: 'none'
                                }}
                            >
                                {isInactive ? "♻️ Reativar Funcionário" : "🚫 Inativar Funcionário"}
                            </Button>
                        );
                    })}
                </ActionButtons>
            </ContainerDivs>
        </Container>
    );
}

export default EmployeeInformation